exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/** [表格主题样式一] 表格强制列不换行 */\n.j-table-force-nowrap {\n  /** 列自适应，弊端会导致列宽失效 */\n}\n.j-table-force-nowrap td,\n.j-table-force-nowrap th {\n  white-space: nowrap;\n}\n.j-table-force-nowrap .ant-table-selection-column {\n  padding: 12px 22px !important;\n}\n.j-table-force-nowrap.ant-table-wrapper .ant-table-content {\n  overflow-x: auto;\n}\n", ""]);

// exports
